import React from 'react';
import { Banner } from 'components/ui/banner';

export enum BannerType {
  warning = 'warning',
  error = 'error',
  info = 'info',
}

interface IProps {
  showBanner: boolean;
  heading?: string;
  message: string;
  type?: BannerType;
  setShowBanner?: () => void;
  listOfError?: boolean;
  fixedHeight?: boolean;
  testId?: string;
  extraLink?: string;
}

const BannerContainer = ({
  showBanner,
  type,
  message,
  heading,
  setShowBanner,
  listOfError = true,
  fixedHeight = true,
  testId,
  extraLink,
}: IProps): JSX.Element | null => {
  if (!showBanner) return null;

  const variant = (type ?? BannerType.warning) as 'warning' | 'error' | 'info';

  const isError = type === BannerType.error;

  let bannerMessage: React.ReactNode = message;
  let details: React.ReactNode;
  if (isError && heading) {
    bannerMessage = heading;
    details = listOfError ? (
      <ul className="mb-0 pl-5">
        <li>{message}</li>
      </ul>
    ) : (
      message
    );
  } else if (!isError && extraLink) {
    details = (
      <a
        href={extraLink}
        className="text-sm font-medium text-muted-foreground hover:underline"
      >
        Learn More
      </a>
    );
  }

  return (
    <Banner
      variant={variant}
      appearance="filled"
      message={bannerMessage}
      details={details}
      showClose={!isError && !!setShowBanner}
      onClose={setShowBanner}
      data-testid={testId}
      className="mb-4"
      style={fixedHeight ? { height: 92 } : undefined}
    />
  );
};

export default BannerContainer;
